import React, { useState } from 'react';
import { useGroupSpecifications } from '../../utils/json/GroupSpecifications';
import Checkmark from '../tags/Checkmark';
import Tag from '../tags/Tag';
import Typography from '../typography/Typography';

type ProductSpecificationsProps = {
  product: Product;
};

const ProductSpecifications = ({ product }: ProductSpecificationsProps) => {
  const [showExtraCategories, setShowExtraCategories] =
    useState<boolean>(false);
  const groupedSpecifications = useGroupSpecifications(product);

  return (
    <div className="my-5 col-span-2">
      <Typography tag="p" type="title">
        Specificaties
      </Typography>
      {groupedSpecifications &&
        Object.entries(groupedSpecifications)
          .slice(0, 2) // Only render the first two categories by default
          .map(([categoryName, specifications]) => (
            <table key={categoryName} className="w-full text-left mt-3">
              <thead className="bg-gray-50 dark:bg-gray-700">
                <tr>
                  <th className="py-2 pl-2">
                    <Typography tag="h1" type="subtitle">
                      {categoryName}
                    </Typography>
                  </th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {specifications.map((specification, index) => (
                  <tr
                    key={index}
                    className={
                      'flex items-center' +
                      (index === specifications.length - 1
                        ? ''
                        : ' border-b dark:border-gray-700')
                    }
                  >
                    <td className="w-1/2 pl-2 py-4">
                      <Typography tag="p" type="default">
                        {specification.spec}
                      </Typography>
                    </td>
                    <td className="w-full flex justify-end">
                      {specification.waarde != null ? (
                        <div>
                          <Typography tag="span" type="semibold">
                            {specification.waarde}
                          </Typography>
                          {specification.stuk && (
                            <>
                              &nbsp;
                              <Typography tag="span" type="semibold">
                                {specification.stuk}
                              </Typography>
                            </>
                          )}
                        </div>
                      ) : specification.bevat == 1 ? (
                        <Checkmark check={1} />
                      ) : (
                        <Checkmark check={0} />
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ))}
      {!showExtraCategories &&
        Object.entries(groupedSpecifications ?? []).length > 2 && (
          <div className="flex justify-center">
            <button onClick={() => setShowExtraCategories(true)}>
              <Tag style={'blue'} label={'Toon meer'} extraClasses="mt-5" />
            </button>
          </div>
        )}
      {showExtraCategories &&
        Object.entries(groupedSpecifications)
          .slice(2) // Render the remaining categories if showExtraCategories is true
          .map(([categoryName, specifications]) => (
            <table key={categoryName} className="w-full text-left mt-3">
              <thead className="bg-gray-50 dark:bg-gray-700">
                <tr>
                  <th className="py-2 pl-2">
                    <Typography tag="h1" type="subtitle">
                      {categoryName}
                    </Typography>
                  </th>
                </tr>
              </thead>
              <tbody>
                {specifications.map((specification, index) => (
                  <tr
                    key={index}
                    className={
                      'flex items-center' +
                      (index === specifications.length - 1
                        ? ''
                        : ' border-b dark:border-gray-700')
                    }
                  >
                    <td className="w-1/2 pl-2 py-4">
                      <Typography tag="p" type="default">
                        {specification.spec}
                      </Typography>
                    </td>
                    <td className="w-full flex justify-end">
                      {specification.waarde != null ? (
                        <div>
                          <Typography tag="span" type="semibold">
                            {specification.waarde}
                          </Typography>
                          {specification.stuk && (
                            <>
                              &nbsp;
                              <Typography tag="span" type="semibold">
                                {specification.stuk}
                              </Typography>
                            </>
                          )}
                        </div>
                      ) : specification.bevat == 1 ? (
                        <Checkmark check={1} />
                      ) : (
                        <Checkmark check={0} />
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ))}
      {showExtraCategories && (
        <div className="flex justify-center">
          <button onClick={() => setShowExtraCategories(false)}>
            <Tag style={'blue'} label={'Toon minder'} extraClasses="mt-5" />
          </button>
        </div>
      )}
    </div>
  );
};

export default ProductSpecifications;
